/**
 * Reference tokens: the raw ramps, straight from the design-samples lab
 * (.context/design-samples/lab-missing-pieces.html §1). Nothing outside
 * theme/tokens should import these — components and overrides consume the
 * semantic layer (./semantic), so a rebrand or a mode only re-points names.
 */
export const sand = {
  0: '#FFFFFF',
  25: '#F2EFE5',
  50: '#F7F5F0',
  100: '#F1EEE7',
  200: '#E2DED2',
  300: '#C9C3B2',
  400: '#9C9584',
  500: '#6E695C',
  700: '#5A564A',
  850: '#2C2921',
  900: '#24221C',
  925: '#232019',
  950: '#1B1915',
} as const

export const amber = {
  400: '#FFC905',
  500: '#F0A800',
  // The star outline: amber 500's hue at full saturation, darkened to 29%
  // lightness, so the mark's border belongs to the star instead of reading as a
  // separate ink line drawn around it. One value serves both modes.
  600: '#966900',
} as const

export const cream = {
  100: '#FFF9E5',
} as const

export const green = {
  100: '#E8F2E4',
  300: '#A8DBAB',
  600: '#256B2A',
  950: '#243122',
} as const

export const red = {
  100: '#FBEAE8',
  300: '#F1988E',
  600: '#B3261E',
} as const

export const navy = {
  600: '#1D3A6C',
} as const

export const ink = {
  900: '#2E2E2D',
} as const
